export default __webpack_public_path__ + "static/media/client-14.b43c83f1.webp";